var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenHi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 104,
    viewBox: "0 0 96 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2529 56.048C72.2529 71.9911 59.3285 84.9155 43.3854 84.9155C27.4423 84.9155 14.5179 71.9911 14.5179 56.048C14.5179 40.1049 27.4423 27.1805 43.3854 27.1805C59.3285 27.1805 72.2529 40.1049 72.2529 56.048Z",
    fill: "#45CA87",
    stroke: "#45CA87",
    strokeWidth: 0.240964
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.915 78.5537L40.6379 98.7224",
    stroke: "#45CA87",
    strokeWidth: 5.66829,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4453 79.855L50.5176 100.385",
    stroke: "#45CA87",
    strokeWidth: 5.66829,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5422 75.6141C73.747 79.9756 66.3976 78.3611 62.0361 71.5659",
    stroke: "#45CA87",
    strokeWidth: 5.66829,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8916 61.9152C9.74699 59.0236 3 44.3248 3 32.9995",
    stroke: "#45CA87",
    strokeWidth: 5.66829,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1802 28.0239C76.1802 39.1893 67.1288 48.2407 55.9633 48.2407C44.7979 48.2407 35.7465 39.1893 35.7465 28.0239C35.7465 16.8584 44.7979 7.80701 55.9633 7.80701C67.1288 7.80701 76.1802 16.8584 76.1802 28.0239Z",
    fill: "#45CA87",
    stroke: "#45CA87",
    strokeWidth: 0.240964
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3016 12.9879C84.3016 19.7085 78.8535 25.1566 72.1329 25.1566C65.4123 25.1566 59.9642 19.7085 59.9642 12.9879C59.9642 6.26731 65.4123 0.819212 72.1329 0.819212C78.8535 0.819212 84.3016 6.26731 84.3016 12.9879Z",
    fill: "#45CA87",
    stroke: "#45CA87",
    strokeWidth: 0.240964
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0723 7.68675C95.0723 11.8655 91.6848 15.253 87.5061 15.253C83.3273 15.253 79.9398 11.8655 79.9398 7.68675C79.9398 3.50801 83.3273 0.120482 87.5061 0.120482C91.6848 0.120482 95.0723 3.50801 95.0723 7.68675Z",
    fill: "#45CA87",
    stroke: "#45CA87",
    strokeWidth: 0.240964
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3386 47.5178C28.2061 44.8672 25.0254 42.3853 21.0977 46.2407",
    stroke: "#1A237E",
    strokeWidth: 2.40964,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2064 45.9997C56.2546 43.9033 52.3992 42.6503 50.0137 47.59",
    stroke: "#1A237E",
    strokeWidth: 2.40964,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2898 52.9156C49.2898 57.9758 45.4344 62.0722 40.0609 62.1445C35.0489 62.2168 31.0489 57.8553 30.9766 52.8433L49.2898 52.9156Z",
    fill: "#F3F2EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHi);
export default __webpack_public_path__ + "static/media/GreenHi.81cedec7ab282b07ef3dbc361f04aa9a.svg";
export { ForwardRef as ReactComponent };